var map = {
	"./blackSmoke15.png": 3978,
	"./explosion00.png": 427,
	"./explosion08.png": 6787,
	"./fart05.png": 5324,
	"./fire1.png": 3355,
	"./fire_02.png": 455,
	"./flame_04.png": 7904,
	"./flash01.png": 7481,
	"./light_01.png": 1554,
	"./particle.png": 6262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2598;